
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon16InfoWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm0 3.98a1.527 1.527 0 1 1-1.527 1.528A1.535 1.535 0 0 1 12 6.98zm2.037 9.222a.437.437 0 0 1-.438.438h-3.198a.437.437 0 0 1-.438-.438v-.86c0-.242.196-.438.438-.438h.437v-2.323h-.437a.437.437 0 0 1-.438-.438v-.86c0-.242.196-.438.438-.438h2.316c.242 0 .438.196.438.438v3.629h.437c.242 0 .437.195.437.437l.008.853z",
  fill: "#FFF"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm0 3.98a1.527 1.527 0 1 1-1.527 1.528A1.535 1.535 0 0 1 12 6.98zm2.037 9.222a.437.437 0 0 1-.438.438h-3.198a.437.437 0 0 1-.438-.438v-.86c0-.242.196-.438.438-.438h.437v-2.323h-.437a.437.437 0 0 1-.438-.438v-.86c0-.242.196-.438.438-.438h2.316c.242 0 .438.196.438.438v3.629h.437c.242 0 .437.195.437.437l.008.853z\" fill=\"#FFF\" fill-rule=\"nonzero\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-16-info-white.287e03ba0ed4a0a2267efa48f82decbf.svg"),
        {
          React: SvgIcon16InfoWhite,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      